import { render, staticRenderFns } from "./CodingTest.vue?vue&type=template&id=1ba2f8f9&scoped=true&"
import script from "./CodingTest.vue?vue&type=script&lang=js&"
export * from "./CodingTest.vue?vue&type=script&lang=js&"
import style0 from "./CodingTest.vue?vue&type=style&index=0&id=1ba2f8f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2f8f9",
  null
  
)

export default component.exports